/* Approved J75/J77 Compare V2. Index-local full-catalog filters; no cart listeners. */
(() => {
  const initialize = root => {
    if (root.dataset.indexReady) return;
    root.dataset.indexReady = 'true';
    const cards = [...root.querySelectorAll('[data-index-card]')];
    const groups = [...root.querySelectorAll('[data-index-group]')];
    const kinds = [...root.querySelectorAll('[data-index-kind]')];
    const families = [...root.querySelectorAll('[data-index-family]')];
    const validFamilies = new Set(families.map(b => b.dataset.indexFamily));
    let kind = 'all', family = 'all';
    const acceptsKind = card => kind === 'all' || card.dataset.kind === kind;
    const draw = () => {
      if (family !== 'all' && !cards.some(c => acceptsKind(c) && c.dataset.family === family)) family = 'all';
      cards.forEach(c => { c.hidden = !acceptsKind(c) || (family !== 'all' && c.dataset.family !== family); });
      groups.forEach(group => {
        const n = [...group.querySelectorAll('[data-index-card]')].filter(c => !c.hidden).length;
        group.hidden = n === 0;
        group.querySelector('[data-index-group-count]').textContent = n;
      });
      families.forEach(button => {
        const f = button.dataset.indexFamily;
        const n = cards.filter(c => acceptsKind(c) && (f === 'all' || c.dataset.family === f)).length;
        button.hidden = n === 0;
        button.querySelector('[data-index-family-count]').textContent = n;
        button.setAttribute('aria-pressed', String(f === family));
      });
      kinds.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.indexKind === kind)));
      root.querySelector('[data-index-empty]').hidden = cards.some(c => !c.hidden);
      root.dispatchEvent(new CustomEvent('osn:comparison-index-filtered', {detail:{kind,family,count:cards.filter(c=>!c.hidden).length}}));
    };
    const read = () => {
      const params = new URL(window.location.href).searchParams;
      kind = ['plants','seeds'].includes(params.get('kind')) ? params.get('kind') : 'all';
      family = validFamilies.has(params.get('family')) ? params.get('family') : 'all';
      draw();
    };
    const write = () => {
      const u = new URL(window.location.href);
      kind === 'all' ? u.searchParams.delete('kind') : u.searchParams.set('kind', kind);
      family === 'all' ? u.searchParams.delete('family') : u.searchParams.set('family', family);
      if (u.href !== window.location.href) window.history.pushState({osnComparisonIndex:true}, '', u);
    };
    root.addEventListener('click', event => {
      const k = event.target.closest('[data-index-kind]');
      const f = event.target.closest('[data-index-family]');
      if (k && root.contains(k)) { kind = k.dataset.indexKind; draw(); write(); }
      else if (f && root.contains(f)) { family = f.dataset.indexFamily; draw(); write(); }
    });
    window.addEventListener('popstate', read);
    read();
  };
  const run = () => document.querySelectorAll('[data-comparison-index="v2"]').forEach(initialize);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',run,{once:true}) : run();
  document.addEventListener('shopify:section:load',run);
})();
